import { GridLayoutColumnProps } from '@updater/ui-uds';

export enum GridCardCtaStatus {
  DEFAULT = 'default',
  SUCCESS = 'success',
  LINKOUT = 'linkout',
}

export interface GridCardProps extends GridLayoutColumnProps {
  /**
   * The card title
   */
  title?: string;
  /**
   * The card's logo image (passed as a React node to support next/image)
   */
  logo: React.ReactElement;
  /**
   * The card's optional subtitle
   */
  subtitle?: string | React.ReactElement;
  /**
   * The card's optional phone number
   */
  phoneNumber?: string;
  /**
   * Sets the data-cy propery of the checkbox for tracking
   */
  dataCy?: string;
  /**
   * Sets the card's cta's status (default, success, linkout)
   */
  status?: GridCardCtaStatus;
  /**
   * The URL used in GridCardCtaStatus.linkout
   */
  href?: string;
  /**
   * Copy used in GridCardCtaStatus.success
   */
  successCopy?: string;
  /**
   * Copy used for the CTA in GridCardCtaStatus.linkout and GridCardCtaStatus.default
   */
  ctaCopy?: string;
  /**
   * Callback function for onClick event (tracking/ GridCardCtaStatus.default)
   */
  onClick?: () => void;
  /**
   * Boolean to switch designs for utility cards
   */
  isUtilityCard?: boolean;
}
